import React from "react";

import { BrowserRouter } from "react-router-dom";
import { Content } from "./components/Content";
import { ConfigurationContextProvider, StepsContextProvider } from "./contexts";

import "bootstrap/dist/css/bootstrap.min.css";
import "antd/dist/antd.css";
import "./custom.css";

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");

// //const ignored = self.__WB_MANIFEST;
// var __WB_MANIFEST = [];

const App = () => {
  return (
    <BrowserRouter basename={baseUrl}>
      <ConfigurationContextProvider>
        <StepsContextProvider>
          <Content></Content>
        </StepsContextProvider>
      </ConfigurationContextProvider>
    </BrowserRouter>
  );
};

export default App;
